import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import loadable from '@loadable/component';
import { isDailyBoostTreatment } from 'src/utils/dailyBoostVariant';

const DailyBoostSpin = loadable(() => import('./DailyBoostSpin/DailyBoostSpin'));
const MilestoneModal = loadable(() => import('./MilestoneModal/MilestoneModal'));

// Dev-only rehearsal params keep the overlays mountable without redux
// state. Statically false in prod builds — dead-code eliminated.
const hasPreviewParams = () => {
  if (process.env.REACT_APP_PRODUCTION === 'TRUE') return false;
  const params = new URLSearchParams(window.location.search);
  return Boolean(
    params.get('tierUpPreview') || params.get('streakWheelPreview'),
  );
};

/**
 * Mount gate for the heavy post-boost overlays. Rendering a loadable
 * starts its chunk download, so rendering these unconditionally in App
 * pulled the wheel, ceremony stylesheet and canvas-confetti on every
 * app load (Codex review). Now the chunks download only when something
 * can actually show — with an idle-time preload for treatment users so
 * the first boost's reveal is still instant.
 */
const DailyBoostOverlays = () => {
  const spinVisible = useSelector((state) => state.dailyBoost.spin.visible);
  const milestoneOpen = useSelector((state) => state.dailyBoost.milestone.open);
  const preview = hasPreviewParams();

  useEffect(() => {
    if (!isDailyBoostTreatment()) return undefined;
    const timer = setTimeout(() => {
      DailyBoostSpin.preload();
      MilestoneModal.preload();
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {spinVisible || preview ? <DailyBoostSpin /> : null}
      {milestoneOpen || preview ? <MilestoneModal /> : null}
    </>
  );
};

export default DailyBoostOverlays;
